import Dialog from '@/components/Dialog/Dialog';
import FileUpload from '@/components/FileUpload';
import { CSVProductOperation } from '@/hooks/product/useMassiveUpload';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import styles from './UploadCSVDialog.styles';
import { useUploadCSVDialogController } from './UploadCSVDialogController';

export function UploadCsvDialog(props: {
  popupType?: CSVProductOperation;
  closeAction: () => void;
}) {
  const { uiState, actions } = useUploadCSVDialogController(
    props.popupType,
    props.closeAction
  );

  return (
    <Dialog
      sx={styles.dialog}
      titleContent={
        <Stack sx={styles.dialogHeaderContainer} direction={'row'}>
          <Typography sx={styles.dialogHeader}>
            {uiState.title ?? ''}
          </Typography>
          <IconButton onClick={actions.handleClose}>
            <CloseOutlinedIcon />
          </IconButton>
        </Stack>
      }
      content={
        <Stack sx={styles.dialogContentContainer}>
          <Stack>
            <Typography sx={styles.sectionTitle}>
              Archivo CSV de catalogo
            </Typography>
            <FileUpload
              heading={uiState.uploadHelperText}
              onChange={(event) =>
                actions.onFileUploaded(event.target.files?.[0])
              }
              accept={['csv']}
            />
          </Stack>
        </Stack>
      }
      actions={
        <Button
          sx={styles.confirmButton}
          variant="contained"
          fullWidth
          disabled={!uiState.continueEnabled}
          onClick={actions.onClickedUploadCsv}
          loading={uiState.isLoading}
        >
          Cargar
        </Button>
      }
      dividers={false}
      open={!!props.popupType}
      onClose={actions.handleClose}
    />
  );
}
